export enum MimeType {
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  PDF = "application/pdf",
  PNG = "image/png",
  JPEG = "image/jpeg",
}
